import React, { useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import { Spacer, Label, ToolBar, Container, SegmentedButton, Button, Panel } from '@sencha/ext-modern'

import { fetchManagerData } from '../Manager/managerUtils'
import FormMessage from '../FormMessage'
import { useInstData, useEventHandler } from 'tyan/public/hooks'

import Grid from './MyGrid'

const Tab = props => {
	const { me, setState, me: { state: {
		list = null
	} } } = useInstData(props)

	const { tab, toolPart, that, reloadStamp } = props
	const config = { ...tab.config }
	const handleDoubleTap = useEventHandler(useCallback((...args) => {
		tab.config.onDoubleTap(that, ...args)
	}, [tab.config.onDoubleTap]))
	tab.config.onDoubleTap && (config.onDoubleTap = handleDoubleTap)

	useEffect(() => {
		fetchManagerData(tab.config.columns, tab.path, {
			tabName: tab.tab, numPerPage: 1000, pageNum: 1,
			onEnd: ({ errorMessage, list }) => {
				if (me.unmounted) return
				!errorMessage && setState({ list })
				errorMessage && Ext.toast(errorMessage)
			}
		})
		// 
	}, [reloadStamp])

	return (
		<Container flex={1} defaults={{ /* autosize: true,  */flex: 1 }} layout={{ type: 'vbox', pack: 'center', align: 'stretch' }}>
			<ToolBar docked="top" ui="app-transparent-toolbar" shadow={false} margin="0 0 0 10" padding="0 10 0 0" layout={{ type: 'hbox', align: 'center' }}>
				{/* <SearchField shadow align="right" ui="solo ks-search-right-trigger" width="280"
      value={searchValue}
      placeholder={`搜索 ...`}
      onChange={handleSearchFieldChange}
      margin="0 10 0 0"
      keyMap={{ 'Ctrl+R': { handler: preventCtrlR } }}
    /> */}
				{/* {renderFiltersButton({ columns: config.columns, ...columnConfig })} */}
				{/* {config.buttons.map((o, i) => {
      const { icon, text, disabled = false, handler, ui = 'action', align = 'left', cdt } = reconfigButton(o)
      return (!cdt || calcMe(cdt)) &&
        <Button margin="0 10 0 0" shadow key={i} iconCls={icon && `x-fa fa-${icon}`} text={text} align={align} ui={ui}
          handler={() => handler && handler(me)}
          disabled={calcMe(disabled)}
        /> || null
    })} */}
				{/* {config.export && <Button shadow iconCls={`x-fa fa-download`} text="导出" ui="action" handler={handleExport} />} */}
				{/* <Spacer /> */}
				{toolPart || null}
				{/* <Panel padding="2 2 2 20" shadow layout={{ type: 'hbox', align: 'center' }} margin='0 0 0 10' style={{ 'border-radius': '3px' }}>
      <Label html={`<div>${total > 0 && `总共 ${total} 条记录，当前 ${list.length} (${beginNum} ~ ${endNum}) 条记录` || `总共 0 条记录`}</div>`} />
      <Button iconCls="x-fa fa-angle-left" text="上一页" handler={handlePrePage} disabled={pageNum === 1} />
      <Button align="right" text={`第 ${pageNum}/${totalPageNum} 页`} menuAlign="tr-br" margin="0 5 0 5" >
        <PageSelect minValue={1} maxValue={totalPageNum} pageNum={pageNum} onPageSelected={handlePageSelected} onChgNumPerPage={handleChgNumPerPage} />
      </Button>
      <Button iconAlign="right" iconCls="x-fa fa-angle-right" text="下一页" handler={handleNextPage} disabled={pageNum === totalPageNum} />
    </Panel> */}
			</ToolBar>
			{list ? <Grid config={config} list={list} that={that} forViewModel={true} /> : <FormMessage text={'加载中 ...'} />}
		</Container>
	)
}

export default connect()(Tab)